<template>
  <div class="detail-page">
    <div class="page-header">
      <slot name="page-header" :titleLabel="titleLabel">
        <div class="page-title">{{ titleLabel }}</div>
        <slot name="title-left"></slot>
      </slot>
    </div>
    <div class="page-content" :style="{width}">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { selectLabelI18n } from '@/i18n'

export default {
  props: {
    title: {
      type: String,
      required: false
    },
    titleI18nKey: {
      type: String,
      required: false
    },
    width: {
      type: String,
      default: '678px'
    }
  },
  data () {
    return {

    }
  },
  computed: {
    titleLabel () {
      return selectLabelI18n(this, 'title')
    }
  },
  created () {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.detail-page {
  .page-header {
    display: flex;
    border-bottom: 1px solid #e4e7ed;

    .page-title {
      padding-top: 4px;
      padding-bottom: 18px;
      line-height: 25px;
      font-size: 18px;
      font-weight: 500;
      color: #303133;
    }
  }

  .page-content {
    margin: 30px auto 0;
    position: relative;
  }
}
</style>
